export default __webpack_public_path__ + "static/profile_outlined-a862ab3dcba84ee3e7224ae9ecc87ef0.png";